import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Feature } from "./Feature";
import { useFeatures } from ".";
import { FeaturesTextOnly } from "./FeaturesTextOnly";
import { useTestId } from "@/hooks";
export const FeaturesPreview = () => {
    const testId = useTestId("Sections.Features.Preview");
    const features = useFeatures();
    if (!features)
        return null;
    const { preview, previewCount, additionalText } = features;
    if (previewCount === 0) {
        return _jsx(FeaturesTextOnly, { additionalText: additionalText });
    }
    return (_jsx(Box, { as: "ul", display: "grid", gridTemplateColumns: {
            "breakpoint.base": "repeat(1, 1fr)",
            "breakpoint.sm": `repeat(${previewCount > 0 ? "2" : "1"}, 1fr)`,
        }, gap: "spacing.16", paddingLeft: "spacing.none", testId: testId, unsafe_className: "FeaturesPreview", children: preview.map((feature) => (_jsx(Box, { as: "li", unsafe_style: { listStyleType: "none" }, children: _jsx(Feature, { feature: feature }) }, feature.value))) }));
};
